<template>
  <div class="p-1">
    <div-table
      :config="configList"
      :data="wallets"
      :element="element"
      @reset="reset"
      @refresh="refresh"
      @filtrer="filtrer"
      @searchSellers="searchSellers"
      @search="search"
      @walletAction="onWalletAction"
      @walletView="openTxModal"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      @Changelimit="Changelimit"
      @selectAllCheckbox="selectAllCheckbox"
      @getRowDetail="getRowDetail"
      :tabId="tabId"
    ></div-table>

    <!-- Deposit / Withdraw modal -->
    <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center p-3" style="background: rgba(0,0,0,0.5);">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        <!-- Header -->
        <div class="flex items-center justify-between px-5 py-4 text-white"
             :style="modalAction === 'withdraw' ? 'background:linear-gradient(135deg,#dc2626,#b91c1c);' : 'background:linear-gradient(135deg,#16a34a,#15803d);'">
          <div class="flex items-center gap-2">
            <i class="material-icons">{{ modalAction === 'withdraw' ? 'remove_circle' : 'add_circle' }}</i>
            <div class="flex flex-col leading-tight">
              <span class="font-bold capitalize">{{ modalAction === 'withdraw' ? 'Retrait' : 'Dépôt' }}</span>
              <span class="text-xs opacity-80">{{ modalSellerName }}</span>
            </div>
          </div>
          <button @click="closeModal" class="text-white hover:opacity-75"><i class="material-icons">close</i></button>
        </div>

        <div class="p-5 space-y-4">
          <!-- Solde actuel -->
          <div class="flex items-center justify-between text-sm bg-gray-50 rounded-lg px-3 py-2">
            <span class="text-gray-500">Solde actuel</span>
            <span class="font-bold text-gray-700">{{ formatBal(modalBalance) }} {{ modalCurrency }}</span>
          </div>

          <!-- Montant (f'devise dyal wallet) -->
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Montant ({{ modalCurrency }})</label>
            <div class="relative">
              <input type="number" v-model.number="form.value" min="0"
                class="w-full border border-gray-300 rounded-lg pl-3 pr-20 py-2.5 text-sm outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                placeholder="0" />
              <div class="absolute inset-y-0 right-0 flex items-center gap-2 pr-3">
                <span class="text-xs text-gray-400 font-semibold">{{ modalCurrency }}</span>
                <button v-if="modalAction === 'withdraw'" type="button" @click="form.value = modalBalance" class="text-xs text-green-600 font-bold hover:underline">MAX</button>
              </div>
            </div>
            <p v-if="modalAction === 'withdraw' && form.value > modalBalance" class="text-xs text-red-500 mt-1">Montant supérieur au solde</p>
          </div>

          <!-- Comment -->
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">{{ $t ? $t('comment') : 'Commentaire' }}</label>
            <textarea v-model="form.comment" rows="2" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"></textarea>
          </div>
        </div>

        <div class="flex gap-3 border-t px-5 py-4">
          <button @click="closeModal" class="w-1/2 px-4 py-2.5 text-center bg-gray-100 text-gray-700 hover:bg-gray-200 font-semibold rounded-lg text-sm">
            {{ $t ? $t('cancel') : 'Annuler' }}
          </button>
          <button :disabled="submitting || !canSubmitModal" @click="submitModal"
            class="w-1/2 px-4 py-2.5 text-center text-white font-semibold rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            :class="modalAction === 'withdraw' ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'">
            <span v-if="!submitting">{{ modalAction === 'withdraw' ? 'Débiter' : 'Créditer' }}</span>
            <span v-else>...</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Transactions modal (in +/out -) -->
    <div v-if="txModal" class="fixed inset-0 z-50 flex items-center justify-center p-3" style="background: rgba(0,0,0,0.5);">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col" style="max-height:90vh;">
        <!-- Header -->
        <div class="flex items-center justify-between px-5 py-4 text-white" style="background:linear-gradient(135deg,#0f766e,#0e7490);">
          <div class="flex items-center gap-2">
            <i class="material-icons">format_list_bulleted</i>
            <div class="flex flex-col leading-tight">
              <span class="font-bold">Transactions</span>
              <span class="text-xs opacity-80">{{ txWallet && txWallet.seller ? (txWallet.seller.fullName || txWallet.seller.email) : '' }}</span>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div v-if="txWallet" class="text-right">
              <div class="text-xs opacity-80">Solde</div>
              <div class="font-bold">{{ txWallet.displayAmount || '' }}</div>
            </div>
            <button @click="closeTxModal" class="text-white hover:opacity-75"><i class="material-icons">close</i></button>
          </div>
        </div>

        <!-- Body -->
        <div class="overflow-auto p-4" style="min-height:200px;">
          <div v-if="txLoading" class="text-center text-gray-400 py-10">...</div>
          <div v-else-if="!txList.length" class="text-center text-gray-400 py-10">
            <i class="material-icons" style="font-size:40px;">inbox</i>
            <p>Aucune transaction</p>
          </div>
          <ul v-else class="divide-y divide-gray-100">
            <template v-for="(h,i) in txList">
            <!-- Séparateur info: devise تبدلت (payment method changé) -->
            <li v-if="i > 0 && txCurrency(txList[i-1]) !== txCurrency(h)" :key="'sep-'+i"
                class="flex items-center gap-1.5 my-1 px-3 py-1.5 text-xs text-blue-700 bg-blue-50 border border-blue-100 rounded-md">
              <i class="material-icons" style="font-size:15px;">info</i>
              <span>Changement de méthode de paiement ({{ txCurrency(h) }} → {{ txCurrency(txList[i-1]) }})</span>
            </li>
            <li :key="i" class="flex items-center justify-between py-3">
              <div class="flex items-center gap-3">
                <div class="rounded-full flex items-center justify-center flex-shrink-0"
                     style="width:36px;height:36px;min-width:36px;"
                     :class="h.operationType === 'in' ? 'bg-green-100' : 'bg-red-100'">
                  <i class="material-icons" style="font-size:20px;line-height:1;"
                     :class="h.operationType === 'in' ? 'text-green-600' : 'text-red-600'">
                    {{ h.operationType === 'in' ? 'arrow_downward' : 'arrow_upward' }}
                  </i>
                </div>
                <div class="flex flex-col leading-tight">
                  <span class="font-semibold text-gray-700 text-sm">
                    {{ h.operationType === 'in' ? 'Crédit (dépôt)' : 'Retrait' }}
                    <span v-if="h.payment" class="text-xs text-gray-400 cursor-pointer hover:text-green-600" @click="$router.push('/payments/detail/'+h.payment)">· facture ↗</span>
                  </span>
                  <span class="text-xs text-gray-400">{{ $moment(h.createdAt).format('DD/MM/YY HH:mm') }}<span v-if="h.comment"> · {{ h.comment }}</span></span>
                  <span v-if="h.status === 'rejected' && h.rejectReason" class="text-xs text-red-500 break-words" :title="h.rejectReason">📝 Motif: {{ h.rejectReason }}</span>
                  <span v-if="h.user && h.user.fullName" class="text-xs text-blue-500 flex items-center gap-0.5"><i class="material-icons" style="font-size:12px;">person</i> {{ h.user.fullName }}</span>
                </div>
              </div>
              <div class="text-right whitespace-no-wrap">
                <div class="font-bold text-sm" :class="h.operationType === 'in' ? 'text-green-600' : 'text-red-600'">{{ txAmount(h) }}</div>
                <span class="text-xs px-2 py-0.5 rounded-full font-medium" :class="txStatusClass(h.status)">{{ h.status }}</span>
              </div>
            </li>
            </template>
          </ul>
        </div>

        <!-- Pagination -->
        <div v-if="txTotal > txPerPage" class="flex items-center justify-between border-t px-5 py-3 bg-gray-50">
          <span class="text-xs text-gray-500">{{ txTotal }} transactions · page {{ txPage }}/{{ txLastPage }}</span>
          <div class="flex items-center gap-2">
            <button @click="txGoTo('prev')" :disabled="txPage <= 1 || txLoading"
              class="px-3 py-1 rounded border text-sm disabled:opacity-40 hover:bg-gray-100">
              <i class="material-icons align-middle" style="font-size:16px;">chevron_left</i>
            </button>
            <button @click="txGoTo('next')" :disabled="txPage >= txLastPage || txLoading"
              class="px-3 py-1 rounded border text-sm disabled:opacity-40 hover:bg-gray-100">
              <i class="material-icons align-middle" style="font-size:16px;">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./configWallets";
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      configList: config.list,
      loading: false,
      wallets: [],
      totals: {},
      element: {},
      sellers: [],
      tabId: [],
      filters: {},
      limit: 100,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      // Modal state
      showModal: false,
      submitting: false,
      modalAction: "deposit",
      selectedSeller: null,
      modalSellerName: "",
      modalCurrency: "MAD",
      modalBalance: 0,
      form: {
        value: null,
        comment: "",
      },
      // Modal transactions
      txModal: false,
      txLoading: false,
      txWallet: null,
      txList: [],
      txPage: 1,
      txPerPage: 20,
      txTotal: 0,
      txLastPage: 1,
    };
  },
  async mounted() {
    // Page CEO — interdite l'Seller/Partner (7tى b'URL directe) => redirect l'profil
    if (this.currentUser && ['Seller', 'Partner'].includes(this.currentUser.type)) {
      this.$router.replace('/profil');
      return;
    }
    if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
    else this.$f.objectToQueryString({ limit: this.limit, country: this.idWharhouse.country });

    if (this.filters.name) await this.search(this.filters.name);
    else await this.getWallets(this.filters);

    if (this.currentUser.type != "Seller") {
      await this.getSellers();
      this.setDataSelect("seller", this.sellers, null);
    }

    if (this.currentUser.type == "Seller") {
      let pos = this.configList.columns.map(function (e) { return e.name; }).indexOf('seller');
      if (pos != -1) this.configList.columns.splice(pos, 1);
    }
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({ user: _.pick(this.currentUser, ['countries']) });
    },
    canSubmitModal() {
      const v = parseFloat(this.form.value);
      if (!v || v <= 0) return false;
      if (this.modalAction === 'withdraw' && v > this.modalBalance) return false;
      return true;
    },
  },
  watch: {
    'warhouseSelected': async function (oldVal, newVal) {

    },
    'idWharhouse': async function (oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.reset();
      if (this.currentUser.type != "Seller") {
        await this.getSellers();
        this.setDataSelect("seller", this.sellers, null);
      }
    }
  },
  methods: {
    /********************** Modal deposit / withdraw **********************/
    // Kayجي mن DivTable actions (deposit/withdraw button per wallet)
    onWalletAction({ action, wallet }) {
      this.openModal(action, wallet);
    },
    /********************** Modal transactions (in +/out -) **********************/
    async openTxModal(wallet) {
      this.txWallet = wallet;
      this.txPage = 1;
      this.txModal = true;
      await this.fetchTx();
    },
    async fetchTx() {
      if (!this.txWallet) return;
      this.txLoading = true;
      this.txList = [];
      try {
        const sellerId = this.txWallet.seller ? (this.txWallet.seller._id || this.txWallet.seller) : null;
        // kل les transactions (in + out) dyal had seller — paginated 20/page
        const res = await this.$server.search("balancesHistories", { seller: sellerId, limit: this.txPerPage, page: this.txPage });
        if (res && res.content && res.content.results) {
          this.txList = res.content.results;
          this.txTotal = res.content.total || 0;
          this.txLastPage = res.content.last_page || 1;
          this.txPage = res.content.current_page || this.txPage;
        } else {
          this.txList = []; this.txTotal = 0; this.txLastPage = 1;
        }
      } catch (e) {
        this.txList = [];
      } finally {
        this.txLoading = false;
      }
    },
    async txGoTo(dir) {
      const next = dir === 'next' ? this.txPage + 1 : this.txPage - 1;
      if (next < 1 || next > this.txLastPage) return;
      this.txPage = next;
      await this.fetchTx();
    },
    closeTxModal() {
      this.txModal = false;
      this.txWallet = null;
      this.txList = [];
      this.txPage = 1;
    },
    txCurrency(h) { return h.defaultCurrency === 'USD' ? 'USD' : 'MAD'; },
    txAmount(h) {
      const cur = this.txCurrency(h);
      const v = parseFloat(cur === 'USD' ? h.amount : h.amountMAD) || 0;
      const shown = cur === 'USD' ? v.toFixed(2) : Math.floor(v);
      const sign = h.operationType === 'in' ? '+' : '-';
      return `${sign} ${shown} ${cur}`;
    },
    txStatusClass(status) {
      if (status === 'paid') return 'bg-green-100 text-green-700';
      if (status === 'rejected') return 'bg-red-100 text-red-700';
      return 'bg-yellow-100 text-yellow-700';
    },
    formatBal(v) {
      const n = parseFloat(v) || 0;
      return this.modalCurrency === 'USD' ? n.toFixed(2) : Math.floor(n);
    },
    openModal(action, wallet) {
      this.modalAction = action;
      this.selectedSeller = wallet.seller ? (wallet.seller._id || wallet.seller) : null;
      this.modalSellerName = wallet.seller ? (wallet.seller.fullName || wallet.seller.email || "") : "";
      // Devise + solde dyal wallet (montant kaydkhل f'devise dyal wallet, l-backend kayحسب l-آخر)
      this.modalCurrency = wallet.defaultCurrency === 'USD' ? 'USD' : 'MAD';
      this.modalBalance = this.modalCurrency === 'USD' ? (parseFloat(wallet.amount) || 0) : (parseFloat(wallet.amountMAD) || 0);
      this.form = { value: null, comment: "" };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.submitting = false;
    },
    async submitModal() {
      if (!this.selectedSeller) return this.$toast.warning("Seller is required");
      const value = parseFloat(this.form.value);
      if (!value || value <= 0) return this.$toast.warning("Montant invalide");
      if (this.modalAction === 'withdraw' && value > this.modalBalance) return this.$toast.warning("Montant supérieur au solde du portefeuille");
      this.submitting = true;
      // montant f'devise dyal wallet — n-صيفطوه f'l-champ صحيح, l-backend kayحسب l-آخر
      const dataAmount = this.modalCurrency === 'USD' ? { amount: value } : { amountMAD: value };
      const data = await this.$server.update("balances", {
        action: this.modalAction,
        data: { seller: this.selectedSeller, ...dataAmount, comment: this.form.comment },
        country: this.idWharhouse ? this.idWharhouse.country : 'MA',
      });
      this.submitting = false;
      if (data && data._id) {
        this.$toast.success(this.modalAction === 'withdraw' ? "Portefeuille débité" : "Portefeuille crédité");
        this.closeModal();
        await this.refresh();
      } else {
        this.$toast.warning(data && data.content ? data.content : data);
      }
    },
    /********************** Table helpers **********************/
    selectAllCheckbox($event) {
      let columns = document.querySelectorAll('.rowCheckbox');
      this.tabId = [];
      if ($event.target.checked == true) {
        columns.forEach(column => {
          column.checked = true;
          this.tabId.push(column.id);
        });
      } else {
        columns.forEach(column => { column.checked = false });
        this.tabId = [];
      }
    },
    getRowDetail(item, id) {
      let itemInRow = this.tabId.filter(item => item === id);
      let isItemInRow = itemInRow.length > 0;

      if (isItemInRow) {
        let pos = this.tabId.map(function (e) { return e; }).indexOf(id);
        this.tabId.splice(pos, 1);
      } else {
        this.tabId.push(id);
      }
      if (this.tabId.length === 0) {
        let columns = document.querySelectorAll('.checkallbbox');
        columns.forEach(column => { column.checked = false });
      }
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getSellers() {
      const filter = {
        type: JSON.stringify(["Seller", "Partner"]),
        countries: this.idWharhouse.country,
        limit: this.limit
      };
      const res = await this.$server.search("users", filter);
      if (res.content.results) this.sellers = res.content.results.map(s => ({ ...s, fullName: s.fullName + ' (' + s.type + ')' }));
      else this.sellers = [];
    },
    searchSellers: _.debounce(async function (search, event) {
      const filter = {
        type: JSON.stringify(["Seller", "Partner"]),
        limit: this.limit,
        countries: this.idWharhouse.country,
        name: search,
      };
      const res = await this.$server.find("users", filter);

      if (res.content.results) this.sellers = res.content.results.map(s => ({ ...s, fullName: s.fullName + ' (' + s.type + ')' }));
      else this.sellers = [];
      this.setDataSelect("seller", this.sellers, null);
    }, 500),
    async reset(data) {
      let lmitt = this.limit;
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      if (this.filters['limit']) lmitt = this.filters['limit'];
      this.filters['page'] = 1;
      this.$f.objectToQueryString({ limit: lmitt, country: this.idWharhouse.country });
      await this.getWallets({ limit: lmitt });
    },
    async filtrer(data) {
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      delete this.filters.page;
      delete this.filters.name;
      this.paginate.currentpage = 1;
      if (!this.filters['limit']) this.filters['limit'] = this.limit;
      if (data.seller) this.filters.seller = data.seller._id || data.seller; else delete this.filters.seller;
      if (data.defaultCurrency) this.filters.defaultCurrency = data.defaultCurrency; else delete this.filters.defaultCurrency;
      this.$f.objectToQueryString(this.filters);
      await this.getWallets(this.filters);
    },
    async refresh() {
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else await this.getWallets(this.filters);
      if (this.filters['page'] && this.filters['page'] > 1 && this.wallets.length == 0) {
        this.filters['page'] = --this.filters['page'];
        this.$f.objectToQueryString(this.filters);
        await this.getWallets(this.filters);
      }
    },
    showOrders(index) {
      if (this.element !== this.wallets[index]) {
        this.element = this.wallets[index];
      } else this.element = null;
    },
    async getWallets(filters) {
      this.loading = true;
      if (this.currentUser.type === "Seller") filters.seller = this.currentUser._id;
      const res = await this.$server.search("balances", {
        ...filters,
        getTotalsByCurrency: true,
      });
      this.loading = false;
      if (res.content.results) {
        // Solde wa7ed 3la 7sab defaultCurrency dyal wallet (stored mn payment method) — MAD default
        this.wallets = res.content.results.map(w => {
          const cur = w.defaultCurrency === 'USD' ? 'USD' : 'MAD';
          const fmt = (v) => cur === 'USD' ? parseFloat(v || 0).toFixed(2) : Math.floor(v || 0);
          const val = cur === 'USD' ? w.amount : w.amountMAD;
          const all = cur === 'USD' ? w.amountUSDAll : w.amountMADAll;
          return { ...w, displayCurrency: cur, displayAmount: `${fmt(val)} ${cur}`, displayTotalAll: `${fmt(all)} ${cur}` };
        });
        this.totals = res.content.totals || {};
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.wallets = [];
        this.totals = {};
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      let limitt = this.limit;
      if (this.filters['limit']) limitt = this.filters['limit'];

      let search = { name: data.trim(), limit: parseInt(limitt), getTotalsByCurrency: true };
      if (this.currentUser.type == "Seller") search.seller = this.currentUser._id;
      this.$f.objectToQueryString(search);
      const res = await this.$server.find("balances", search);
      if (res.content.results) {
        this.wallets = res.content.results;
        this.totals = res.content.totals || {};
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.wallets = [];
        this.totals = {};
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      this.filters['page'] = page;
      this.$f.objectToQueryString(this.filters);
      this.getWallets(this.filters);
    },
    async Changelimit(val) {
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      this.filters['limit'] = val;
      this.filters['page'] = 1;
      this.paginate.currentpage = 1;
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else this.getWallets(this.filters);
    },
  },
};
</script>

<style>
@media (min-width: 640px) {
  thead tr:not(:first-child) {
    display: none;
  }
}

td:not(:last-child) {
  border-bottom: 0;
}

th:not(:last-child) {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}
</style>
